export const DEV_STATUS_IN_PRODUCTION = 'IN PRODUCTION';
export const DEV_STATUS_IN_TESTING = 'IN TESTING';
export const DEVELOPMENT_STATUS_VALUES = [DEV_STATUS_IN_PRODUCTION, DEV_STATUS_IN_TESTING];

export const DEFAULT_SITE_ICON = '/static/dashboard/img/phones.svg';
export const SINGULAR_DEFAULT_SITE_ICON =
    'https://cdn.singular.net/dashboard/icon/1dbacc8dc07551adf8fffa21d4dee93a79f37105';

export const IOS_PLATFORM = 'ios';
export const ANDROID_PLATFORM = 'android';
export const WEB_PLATFORM = 'web';
export const OTHER_PLATFORM = 'other';

export const DEFAULT_PLATFORM = ANDROID_PLATFORM;
export const NEW_APP_ID = 'new_app_id';

export const OS_LIST = [
    ANDROID_PLATFORM,
    IOS_PLATFORM,
    WEB_PLATFORM,
    'pc',
    'xbox',
    'playstation',
    'nintendo',
    'metaquest',
    'ctv',
    OTHER_PLATFORM,
];
